import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { TextInputLabel, RequiredFieldDivError } from "./AddEditClient.styled";
import {
  autoSearchInputStylesError,
  autoSearchInputStyles,
} from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";

const HolderCompany = (props) => {
  const { t, formData, setFormData, objectId, selectedHolderCompany } = props;

  const countryId = UserInfo.countryId();
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isCompanySuggestionsLoading, setCompanySuggestionsLoading] =
    useState(false);

  useEffect(() => {
    setFormData({
      ...formData,
      company: {
        value: selectedCompany,
        error: "",
        required: true,
      },
    });
  }, [selectedCompany]);

  useEffect(() => {
    if (selectedHolderCompany?.companyId) {
      let entityGroupList = [];
      if (formData?.company?.value) {
        entityGroupList.push({
          name:
            selectedHolderCompany?.companyId +
            " - " +
            selectedHolderCompany?.companyName,
          id: selectedHolderCompany?.companyId,
        });
      }
      setSelectedCompany(entityGroupList[0]);
    } else if (objectId !== null) {
      const url = `/general/search?search=&limit=100&countries=[${countryId}]&objectId=${objectId}&objectTypes=["company"]`;
      getEntityData(url, "selectedDefault");
    }
  }, []);

  const searchEntity = (e) => {
    const search = e.target.value;
    if (search.length >= 3) {
      let url = `/general/search?search=${search}&limit=100&countries=[${countryId}]&objectTypes=["company"]`;
      getEntityData(url, "all");
    }
  };
  const getEntityData = (url, type) => {
    setCompanySuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        let entityGroupList = [];
        if (response?.data?.companies) {
          response.data.companies.map((key) => {
            entityGroupList.push({
              name: key.id + " - " + key.name,
              id: key.id,
            });
          });
          setCompanyList(entityGroupList);
          setCompanySuggestionsLoading(false);
          if (
            type === "selectedDefault" &&
            response.data.companies.length === 1
          ) {
            setSelectedCompany(entityGroupList[0]);
          }
        }
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching entities",
            error
          );
        }
        setCompanyList([]);
        setCompanySuggestionsLoading(false);
      });
  };

  return (
    <>
      <TextInputLabel error={formData.company.error}>
        {" "}
        {t("CONTACT_COMPANY")}
        {isCompanySuggestionsLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </TextInputLabel>
      <Autocomplete
        id="tags-outlined"
        options={companyList}
        getOptionLabel={(option) => option.name || " "}
        style={{ zIndex: 99 }}
        filterSelectedOptions
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder=""
            size="small"
            style={
              formData.company.error !== ""
                ? autoSearchInputStylesError
                : autoSearchInputStyles
            }
          />
        )}
        value={selectedCompany}
        onKeyUp={searchEntity}
        onChange={(event, newValue) => {
          setSelectedCompany(newValue);
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
      {formData.company.error !== "" && (
        <RequiredFieldDivError>{formData.company.error}</RequiredFieldDivError>
      )}
    </>
  );
};

HolderCompany.propTypes = {
  t: PropTypes.func.isRequired,
  objectId: PropTypes.number,
};

HolderCompany.defaultProps = {
  objectId: null,
};
export default withTranslation()(HolderCompany);
